import {Pipe, PipeTransform} from '@angular/core';
import { ProductService } from '@aparraga/ahoracrypto-client-common/src/app/common/product/product.service';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'cryptosymbol2name',
    standalone: false
})
export class CryptoSymbol2NamePipe implements PipeTransform {

  constructor(protected productService: ProductService) {

  }

  transform(symbol: string): Observable<string> {
    return from(this.productService.getProduct(symbol)).pipe(
      map(product => product ? product.name : '')
    );
  }

}

